import type { FilterObject, Filter, Sort } from '@agapi/mlc-core';
import type { ProductCollectionResult } from '../../types/collections';

import { PUBLIC_INCLUDE_BRAND_SLUG_IN_COLLECTIONS, PUBLIC_BRAND_SLUG } from '$env/static/public';

import { getCommerce } from '../../services';
import { getCookie } from '../../utils/cookies.client';
import { getLocaleFromUrl, removeLocaleFromPath } from '../../utils/locale.shared';
import { getDefaultFacets } from '../../utils/collections.shared';

export async function loadProducts(this: {
  filter?: Filter[]
},
  offset: number,
  limit: number,
  url: URL,
  facetFilter: Record<string, FilterObject> = {},
  sortBy?: Sort,
): Promise<ProductCollectionResult> {
  const COMMERCE = getCommerce(window.fetch);
  const fullCollectionSlug = PUBLIC_INCLUDE_BRAND_SLUG_IN_COLLECTIONS === 'true' ? `/${PUBLIC_BRAND_SLUG}${removeLocaleFromPath(url.pathname)}` : removeLocaleFromPath(url.pathname);

  const locale = getLocaleFromUrl(url);

  const combinedFilterFacets: Record<string, FilterObject> = {
    ...getDefaultFacets(locale),
    ...facetFilter as Record<string, FilterObject>
  };

  const response = await COMMERCE.getProducts({
    attribute: { name: 'collections_full_slugs', value: fullCollectionSlug },
    facetFilter: combinedFilterFacets,
    ...(sortBy ? { sortBy: [sortBy] } : {}),
    ...(this?.filter ? { filter: this.filter } : {}),
    offset,
    limit
  },
  getLocaleFromUrl(url),
  {
    userId: getCookie('__agapi_identifier') ?? 'default'
  });

  return {
    ...response,
    filtersSelected: combinedFilterFacets
  };
}

export const loadProductsForCampaigns = loadProducts.bind({
  filter: [{
    type: 'attribute',
    attributeName: 'price_discount',
    value: 0,
    comparisonMode: 'greaterThan'
  }]
});
